module.exports = __webpack_public_path__ + "static/media/person-carry.23f542ae.svg";